<template>
  <b-overlay
    :show="show"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
    <b-card
      v-if=" sendReceiptCard"
      no-body
    >
      <b-row>
        <b-col
          sm="6"
          class="card-border"
        >
          <b-card-body>
            <div class="text-center text-md-left mt-3">
              <h3 :class="$store.state.appConfig.layout.skin === 'dark'?'text-white':'text-primary'">
                {{ $t('forex.online-crypto-deposit-title') }}
              </h3>
              <p>{{ $t('forex.online-crypto-deposit-description', { currency: formData.currency.name }) }}</p>
              <GetDescription name="online-forex-crypto-deposit" />
            </div>

            <!-- images -->
            <b-img
              fluid
              :src="require('@/assets/images/illustration/pricing-Illustration.svg')"
              class="pricing-trial-img"
              alt="svg img"
            />
            <!--/ images -->
          </b-card-body>
        </b-col>
        <b-col sm="6">
          <b-card-body>
            <b-alert
              class="p-2"
              show
              variant="danger"
            >
              <p v-if="formData.currency.name">
                {{ $t('deposit-warning-dec', { currency:`${formData.currency.name+'-'+formData.currency.token} ${formData.network.name?'('+ formData.network.name+')':''} ` }) }}
              </p>
            </b-alert>
            <div class="my-2">
              <metatraderAccountDetail
                :acc="accountDetail"
              />
            </div>
            <b-alert
              v-show="accountDetail.max_deposit || accountDetail.min_deposit"
              id="max-min-deposit-alert"
              show
              variant="warning"
              class="p-1"
            >
              <div class="alert-body">
                <p class="text-justify">
                  {{ $t('deposit-msg', { group: accountDetail.group , min:numberWithCommas(accountDetail.min_deposit || 0) , max:numberWithCommas(accountDetail.max_deposit || 0) }) }}
                </p>
                <p
                  v-if="accountDetail.min_deposit"
                  class="text-justify"
                >
                  {{ $t('min-deposit-msg', { min:numberWithCommas(accountDetail.min_deposit || 0) }) }}
                </p>
                <p
                  v-if="accountDetail.max_deposit"
                  class="text-justify"
                >
                  {{ $t('max-deposit-msg', {max:numberWithCommas(accountDetail.max_deposit || 0) }) }}
                </p>
              </div>
            </b-alert>
            <b-form
              class="mt-2"
            >
              <validation-observer ref="cryptoDepostForm">
                <b-row>
                  <b-col md="6">
                    <b-form-group
                      :label="$t('forex.account-number')"
                      label-for="account-number"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        :name="$t('forex.account-number')"
                        vid="account-number"
                        rules="required"
                      >
                        <v-select
                          id="account-number"
                          v-model="formData.account"
                          :options="accountsItems"
                          :clearable="false"
                          label="account"
                          :dir="$store.state.appConfig.layout.isRTL?'rtl':'ltr'"
                          :disabled="inProgressDeposit"
                          @input="onchangeAccountDetail"
                        />

                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group
                      :label="$t('forex.platform')"
                      label-for="platform"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        :name="$t('forex.platform')"
                        vid="platform"
                        rules="required"
                      >
                        <v-select
                          id="platform"
                          v-model="formData.platform"
                          :options="platform"
                          label="name"
                          :dir="$store.state.appConfig.layout.isRTL?'rtl':'ltr'"
                          :clearable="false"
                          disabled
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <b-form-group
                      label-for="coin"
                      :label="$t('coin')"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        :name="$t('coin')"
                        vid="coin"
                        rules="required"
                      >
                        <v-select
                          v-model="formData.currency"
                          :options="currencyItems"
                          label="name_token"
                          :clearable="false"
                          :disabled="inProgressDeposit"
                          :dir="$store.state.appConfig.layout.isRTL?'rtl':'ltr'"
                          @input="onCurrencyChange"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col
                    cols="12"
                    class="pb-1"
                  >
                    <b-form-group
                      label-for="network"
                      :label="$t('Network')"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        :name="$t('Network')"
                        vid="network"
                        rules="required"
                      >
                        <v-select
                          id="network"
                          v-model="formData.network"
                          :options="networkItems"
                          label="name"
                          :disabled="!formData.currency || inProgressDeposit"
                          :clearable="false"
                          :dir="$store.state.appConfig.layout.isRTL?'rtl':'ltr'"
                          @input="onNetworkChange"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                    <span
                      v-if="formData.currency.name && formData.network && formData.network.name"
                      class="text-danger"
                    >{{ $t('deposit-warning-dec2',
                           { currency: `${formData.currency.name+'-'+formData.currency.token} ${'('+ formData.network.name+')'} ` }) }}
                    </span>
                    <b-alert
                      v-if="formData.network && formData.network.name"
                      variant="info"
                      show
                      class="mt-2 p-2"
                    >
                      {{ $t('commission') }}: {{ formData.network.commission+' '+formData.currency.token }}
                      <br>
                      {{ $t('auto-crypto-deposit-commission-desc') }}
                    </b-alert>
                  </b-col>
                </b-row>
              </validation-observer>
              <b-button
                v-if="!inProgressDeposit"
                variant="info"
                class="mt-2 mb-2 w-100"
                :disabled="!formData.currency || !formData.network || inProgressDeposit"
                @click="onRequestWallet"
              >
                {{ $t('request_wallet_address') }}
              </b-button>
            </b-form>
            <b-alert
              v-if="walletAddress && inProgressDeposit"
              variant="warning"
              show
              class="mt-2 p-2"
            >
              {{ $t('in_progress_deposit_time_message') }}
            </b-alert>
            <b-alert
              v-if="walletAddress && inProgressDeposit"
              variant="success"
              show
              class="mt-2 p-2"
            >
              {{ $t('in_progress_deposit_account_message') }}
            </b-alert>
            <b-row v-if="inProgressDeposit">
              <b-col
                xs="12"
                md="6"
                class="mb-1 mb-md-0"
              >
                <b-button
                  variant="danger"
                  class="w-100"
                  :disabled="!inProgressDeposit"
                  @click="onCancelDeposit"
                >
                  {{ $t('cancel_deposit') }}
                </b-button>
              </b-col>
              <b-col
                xs="12"
                md="6"
              >
                <b-button
                  variant="success"
                  class="w-100"
                  :disabled="!inProgressDeposit"
                  @click="onExtendDeposit"
                >
                  {{ $t('extend_time') }}
                  <span v-if="inProgressDeposit">({{ secondsToTime(inProgressDepositExtendTime) }})</span>
                </b-button>
              </b-col>
            </b-row>
            <br>
            <b-col
              v-if="walletAddress"
              cols="12"
            >
              <b-alert
                variant="success"
                show
                class="mb-2 p-1"
              >
                {{ $t('deposit_desired_amount_to_this_wallet_address') }}
              </b-alert>
              <b-form-group
                id="popover-manual-1"
                label-for="walletAddress"
                :label="$t('walletAddress')"
              >
                <copy-to-clipboard
                  :text="walletAddress"
                  @copy="pop1 = true"
                >
                  <b-input-group class="mb-2">
                    <b-form-input
                      id="walletAddress"
                      v-model="walletAddress"
                      readonly
                      name="walletAddress"
                      :placeholder="$t('walletAddress')"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        icon="CopyIcon"
                        size="20"
                      />
                    </b-input-group-append>
                  </b-input-group>
                </copy-to-clipboard>
                <b-popover
                  target="popover-manual-1"
                  :show.sync="pop1"
                  triggers="click"
                  placement="bottom"
                >
                  {{ $t('copied') }}
                </b-popover>
              </b-form-group>
            </b-col>
            <div
              class="mt-2 text-center mx-auto d-flex justify-content-center align-center"
            >
              <qrcode-vue
                v-if="walletAddress"
                :value="walletAddress"
                :background="isDarkTheme ? '#283046' : '#fff'"
                :foreground="isDarkTheme ? '#fff' : '#283046'"
                :size="qrsize"
                class="qrcode"
              />
            </div>
            <b-alert
              v-if="inProgressDeposit"
              variant="success"
              show
              class="mt-2 p-2 text-center"
            >
              <span>
                {{ $t('deposit_time_remaining') }}
                <span v-if="inProgressDeposit">({{ secondsToTime(inProgressDepositTime) }})</span>
              </span>
            </b-alert>
            <br>
            <br>
            <!-- <b-row v-if="$options.components.bonusForm">
              <b-col>
                <component
                  :is="'bonusForm'"
                  @onAccepted="setBonusCode"
                />
              </b-col>
            </b-row> -->
          </b-card-body>
        </b-col>
      </b-row>
    </b-card>
    <b-card v-if="!sendReceiptCard">
      <h4
        class="text-justify"
        style="line-height: normal;"
      >
        {{ $t('deposit-desc') }}
      </h4>
    </b-card>
    <b-overlay
      :show="listloading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card
        v-if="items.length > 0"
        class="d-none d-sm-block"
        :title="$t('lastDeposits')"
      >
        <b-row align-h="center">
          <b-col cols="12">
            <b-table
              responsive
              striped
              hover
              sticky-header="1000px"
              :items="items"
              :fields="fields"
            >
              <template #cell(date)="data">
                <span>
                  {{ moment(data.item.created_at).format('YYYY-MM-DD HH:mm:ss') }}
                </span>
              </template>
              <template #cell(amount)="data">
                <span>
                  {{ numberWithCommas(data.item.amount) }}
                </span>
              </template>
              <template
                #cell(tx_id)="data"
              >
                <span
                  class="text-wrap"
                  dir="ltr"
                >
                  <span>
                    {{ data.item.tx_id ? data.item.tx_id.slice(0,10) : null }}
                  </span>
                  <span>..</span>
                  <span>
                    <feather-icon
                      :id="`popover-button-variant3-${data.item.id}`"
                      icon="HelpCircleIcon"
                      class="cursor-pointer  mx-1"
                      size="20"
                      href="#"
                      tabindex="0"
                    />
                    <b-popover
                      placement="top"
                      :target="`popover-button-variant3-${data.item.id}`"
                      variant="secondary"
                      triggers="focus"
                    >
                      <template #title />
                      {{ data.item.tx_id }}
                    </b-popover>
                  </span>

                </span>
              </template>
              <template #cell(status)="data">
                <div class="d-flex align-items-center">
                  <b-button
                    :variant="data.item['status'] === 'pending' ? 'warning' : data.item['status'] === 'success' ? 'success' :data.item['status']? 'danger':''"
                    size="sm"
                    style="display: block; width: 140px"
                    @click="openInfoTransactionModal(data.item)"
                  >
                    {{ $t('forex.'+data.item.action) }} / {{ $t(data.item.status) }}
                  </b-button>
                </div>

              </template>
            </b-table>

          </b-col>
          <b-col cols="auto">
            <b-pagination
              v-if="totalTransactions > perPageTransactions"
              v-model="currentpageTransactions"
              :total-rows="totalTransactions"
              :per-page="perPageTransactions"
              align="fill"
              size="sm"
              class="mb-1"
            />
          </b-col>
        </b-row>
      </b-card>

      <b-card
        v-if="items.length > 0"
        class="d-sm-none"
        :title="$t('lastDeposits')"
      >
        <b-row
          align-h="center"
        >
          <b-col cols="12">
            <div
              v-for="(item, index) in items"
              :key="index"
              :class="$store.state.appConfig.layout.skin === 'dark' ? 'card-bg' : 'transaction-card'"
              class="mb-2"
            >
              <div class="d-flex justify-content-between">
                <div>{{ $t('id') }}</div>
                <h5>{{ item.id }}</h5>
              </div>
              <div class="d-flex justify-content-between mt-1">
                <div>{{ $t('coin') }}</div>
                <h5>{{ item.currency_network.currency.token }}</h5>

              </div>
              <div class="d-flex justify-content-between mt-1">
                <div>{{ $t('Network') }}</div>
                <h5>{{ item.currency_network.network.nick_name }}</h5>

              </div>
              <div class="d-flex justify-content-between mt-1">
                <div>{{ $t('amount') }}</div>
                <h5>{{ numberWithCommas(item.amount) }}</h5>

              </div>
              <div
                class="d-flex justify-content-between mt-1"
              >
                <div>{{ $t('transaction_id') }}</div>
                <span class="d-flex">

                  <h5>
                    {{ item.tx_id ? item.tx_id.slice(0,10) : null }}
                  </h5>
                  <h5>..</h5>

                  <feather-icon
                    :id="`popover-button2-variant-${item.id}+mobilee`"
                    icon="HelpCircleIcon"
                    class="cursor-pointer"
                    size="20"
                    href="#"
                    tabindex="0"
                  />
                  <b-popover
                    placement="top"
                    :target="`popover-button2-variant-${item.id}+mobilee`"
                    variant="secondary"
                    triggers="focus"
                  >
                    <template #title />
                    {{ item.tx_id }}
                  </b-popover>

                </span>
              </div>
              <div class="d-flex justify-content-between mt-1">
                <div>{{ $t('date') }}</div>
                <h5>{{ moment(item.created_at).format('YYYY-MM-DD') }}</h5>

              </div>
              <div class="d-flex justify-content-between mt-1">
                <div>{{ $t('status') }}</div>
                <div class="d-flex align-items-center">

                  <b-button
                    :variant="item['status'] === 'pending' ? 'warning' : item['status'] === 'success' ? 'success' :item['status']? 'danger':''"
                    size="sm"
                    style="display: block; width: 140px"
                  > {{ $t('forex.'+item.action) }} / {{ $t(item.status) }}</b-button>
                </div>

              </div>
            </div>
          </b-col>
          <b-col cols="auto">
            <b-pagination
              v-if="totalTransactions > perPageTransactions"
              v-model="currentpageTransactions"
              :total-rows="totalTransactions"
              :per-page="perPageTransactions"
              align="fill"
              size="sm"
              class="mb-1"
            />
          </b-col>
        </b-row>
      </b-card>
    </b-overlay>

    <b-modal
      v-model="infoTransactionModal"
      :title="selectedTransaction ? $t('info_transaction_modal', { id: selectedTransaction[0].id }) : ''"
      hide-footer
      size="lg"
      modal-class="transaction-modal"
    >
      <b-alert
        v-if="selectedTransaction && selectedTransaction[0].detail.reject_reason"
        variant="danger"
        show
      >
        <h5 class="alert-heading">
          {{ $t('rejectDescription') }}:
        </h5>
        <div class="alert-body p-2">
          <p>
            {{ selectedTransaction && selectedTransaction[0].detail.reject_reason }}
          </p>
        </div>
      </b-alert>
      <!-- request info -->
      <h5 class="mt-1">
        {{ $t('request_info') }}
      </h5>
      <b-table
        hover
        responsive
        :items="selectedTransaction"
        :fields="transactionModalRequestFields"
      />
      <hr>
    </b-modal>
  </b-overlay>
</template>
<script>
import {
  BOverlay, BForm, BFormGroup, BCard, BRow, BCol, BImg, BCardBody, BTable,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BPopover,
  BButton,
  BPagination,
  BModal,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

import Ripple from 'vue-ripple-directive'
import CopyToClipboard from 'vue-copy-to-clipboard'
import QrcodeVue from 'qrcode.vue'
import {
  required, size, numeric, numberOrDecimal,
  decimalPoints,
} from '@validations'
import MetatraderService from '@/modules/forex/service/apis'
import metatraderAccountDetail from '@/modules/forex/views/metatrader/metatraderAccountDetail.vue'
import { resizeImage, numberWithCommas } from '@/utils'
import moment from '@/libs/moment'
import { alphanumeric } from '@/mixins/alphanumeric'
import ProfileApis from '@/services/apis/profile'
import GetDescription from '@/views/theme1/components/getDescription.vue'
import MetatraderAutomaticCryptoDepositApis from '../../service/apis/automaticCryptoDepposit'

const metaTrader = new MetatraderService()
const MetatraderAutomaticCryptoDeposit = new MetatraderAutomaticCryptoDepositApis()
const profile = new ProfileApis()

export default {
  components: {
    GetDescription,
    BOverlay,
    BForm,
    BFormGroup,
    BCard,
    BRow,
    BCol,
    BImg,
    BCardBody,
    BFormInput,
    CopyToClipboard,
    BInputGroup,
    BInputGroupAppend,
    BPopover,
    QrcodeVue,
    BButton,
    BTable,
    BPagination,
    vSelect,
    metatraderAccountDetail,
    BModal,
    bonusForm: () => process.env.VUE_APP_ACTIVE_MODULES.split(',').includes('BONUS')
     && import('@/modules/bonus/views/components/form.vue'),
  },
  directives: {
    Ripple,
  },
  mixins: [alphanumeric],
  data() {
    return {
      required,
      size,
      numeric,
      moment,
      numberOrDecimal,
      decimalPoints,
      show: false,
      sendReceiptCard: true,
      coin: '',
      walletAddress: '',
      pop1: false,
      currentpageTransactions: 1,
      totalTransactions: 0,
      perPageTransactions: 10,
      qrsize: 150,
      inProgressDeposit: false,
      inProgressDepositTime: 0,
      inProgressDepositTimer: '',
      inProgressDepositExtendTime: 0,
      inProgressDepositExtendTimer: '',
      items: [],
      // Sample crypto data with their networks
      cryptoData: [
        {
          symbol: 'BTC',
          networks: [
            { name: 'Bitcoin', code: 'BTC' },
            { name: 'BEP20', code: 'BSC' },
            { name: 'TRC20', code: 'TRX' },
          ],
        },
        {
          symbol: 'ETH',
          networks: [
            { name: 'ERC20', code: 'ETH' },
            { name: 'BEP20', code: 'BSC' },
          ],
        },
        {
          symbol: 'USDT',
          networks: [
            { name: 'ERC20', code: 'ETH' },
            { name: 'TRC20', code: 'TRX' },
            { name: 'BEP20', code: 'BSC' },
          ],
        },
        {
          symbol: 'BNB',
          networks: [
            { name: 'BEP20', code: 'BSC' },
          ],
        },
      ],
      currencyItems: [],
      networkItems: [],
      accountsItems: [],
      platform: [
        { title: 'metatrader 4', value: 'mt4' },
        { title: 'metatrader 5', value: 'mt5' },
      ],
      formData: {
        account: {},
        platform: '',
        currency: '',
        network: '',
        amount: '',
        tx_id: '',
      },
      bonusCode: '',
      uploadSize: 0,
      currentUpload: 0,
      pending: false,
      listloading: false,
      accountDetail: {
        account: '',
        balance: '',
        equity: '',
        group: '',
        leverage: '',
        margin: '',
      },
      numberWithCommas,
      infoTransactionModal: false,
      selectedTransaction: null,
      poolingInterval: null,
      timerTimeout: null,
    }
  },

  computed: {
    isDarkTheme() {
      return this.$store.state.appConfig.layout.skin === 'dark'
    },
    MAX_IMAGE_UPLOAD_SIZE() {
      return process.env.VUE_APP_MAX_IMAGE_UPLOAD_SIZE
    },
    fields() {
      return [
        {
          label: this.$t('id'),
          key: 'id',
          tdClass: 'nameOfTheClass',
        },
        {
          label: this.$t('coin'),
          key: 'currency_network.currency.token',
          tdClass: 'nameOfTheClass',
        },
        {
          label: this.$t('Network'),
          key: 'currency_network.network.nick_name',
          tdClass: 'nameOfTheClass',
        },
        {
          label: this.$t('amount'),
          key: 'amount',
          tdClass: 'nameOfTheClass',
        },
        {
          label: this.$t('transaction_id'),
          key: 'tx_id',
          tdClass: 'nameOfTheClass',
        },
        {
          label: this.$t('date'),
          key: 'date',
          tdClass: 'nameOfTheClass',
        },
        {
          label: this.$t('status'),
          key: 'status',
          tdClass: 'nameOfTheClass',
        },
      ]
    },
    transactionModalRequestFields() {
      return [
        {
          label: this.$t('account'),
          key: 'account',
        },
        {
          label: this.$t('amount'),
          key: 'amount',
        },
        {
          label: this.$t('currency'),
          key: 'currency',
        },
      ]
    },
  },
  watch: {
    pop1(val) {
      if (val) {
        setTimeout(() => {
          this.pop1 = false
        }, 2500)
      }
    },
    currentpageTransactions(val) {
      if (val) {
        this.list()
      }
    },
    '$store.state.Messaging.event': {
      async handler(newVal) {
        if (newVal === 'forex_online_crypto_deposit') {
          await this.list()
        }
      },
      immediate: true,
    },
  },

  async mounted() {
    this.show = true

    await this.getData()
    await this.list()
    await this.getCurrency()
    await this.getActiveDeposit()

    this.poolingInterval = setInterval(async () => {
      await this.getActiveDeposit()
    }, 15000)

    this.show = false
  },
  beforeDestroy() {
    if (this.poolingInterval) {
      clearInterval(this.poolingInterval)
    }
    if (this.timerTimeout) {
      clearTimeout(this.timerTimeout)
    }
  },
  methods: {
    async getData() {
      Promise.all([
        metaTrader.getPlatforms().then(res => {
          this.platform = res.data.results
        }),
        await metaTrader.getAccounts().then(res => {
          this.accountsItems = res.data.results
          // eslint-disable-next-line prefer-destructuring
          this.formData.account = res.data.results[0]
          // eslint-disable-next-line prefer-destructuring
          if (res.data.results[0]) this.accountDetail = res.data.results[0]

          this.formData.platform = this.platform.find(plat => plat.value === this.accountDetail.platform)

          if (this.$route.params.id) {
            const accountDetail = res.data.results.find(item => item.account === parseInt(this.$route.params.id, 10))
            this.formData.account = accountDetail
            this.accountDetail = accountDetail
            this.formData.platform = this.platform.find(plat => plat.value === accountDetail.platform)
          }
        }),
      ]).catch(err => {
        console.log(err)
      })
    },
    async getCurrency() {
      await MetatraderAutomaticCryptoDeposit.cryptoCurrencyList().then(res => {
        const currencies = res.data.results.map(item => ({ ...item, name_token: `${item.name} (${item.token})`, currencyNetwork: `${item.currency} (${item.network})` }))
        this.currencyItems = currencies
        const [firstCurrency] = currencies
        this.formData.currency = firstCurrency
        this.onCurrencyChange(firstCurrency)
        // this.networkItems = [{ network: firstCurrency.network }]
        // this.formData.network = firstCurrency.network
      })
    },
    onchangeAccountDetail(item) {
      this.accountDetail = item
      this.formData.platform = this.platform.find(plat => plat.value === item.platform)
      const alert = document.getElementById('max-min-deposit-alert')
      const isMobile = window.matchMedia('(max-width: 767px)').matches
      if ((item.max_deposit || item.min_deposit) && alert && isMobile) {
        alert.scrollIntoView()
      }
    },
    async save() {
      const valid = await this.$refs.cryptoDepostForm.validate()
      if (!valid) return
      this.pending = true
      const data = {
        ...this.formData,
        amount: this.formData.amount.replace(/,/g, ''),
        account: this.formData.account.account,
        currency: this.formData.currency.currency,
        platform: this.formData.platform.value,
        ...(this.bonusCode && { bonus_code: this.bonusCode }),
      }
      metaTrader.saveCryptoDeposit(data, e => {
        this.uploadSize = e.total
        this.currentUpload = e.loaded
        profile.get()
      }).then(res => {
        this.$swal({
          title: res.data.message,
          icon: 'success',
          timer: 2500,
          showConfirmButton: false,
        })
        this.sendReceiptCard = false
        this.list()
      }).finally(() => {
        this.pending = false
      })
    },
    list() {
      this.listloading = true
      MetatraderAutomaticCryptoDeposit.getDeposits({ per_page: this.perPageTransactions, page: this.currentpageTransactions }).then(res => {
        this.items = res.data.results.data
        this.totalTransactions = res.data.results.paginate.total
        this.currentpageTransactions = res.data.results.paginate.current_page
        this.perPageTransactions = Number(res.data.results.paginate.per_page)
      }).finally(() => {
        this.listloading = false
      })
    },
    onCurrencyChange(selectedCurrency) {
      if (selectedCurrency) {
        this.networkItems = selectedCurrency.networks.map(network => ({
          ...network,
          name: `${network.network.name} (${network.network.nick_name})`,
        }))
        this.formData.network = [] // Reset network selection
        this.walletAddress = '' // Reset wallet address until network is selected
      }
    },
    async onRequestWallet() {
      const valid = await this.$refs.cryptoDepostForm.validate()
      if (!valid) return
      this.show = true
      this.walletAddress = ''
      // alert(JSON.stringify(this.formData.account))
      const data = {
        platform_account: this.formData.account.account,
        currency: this.formData.currency.token,
        network: this.formData.network.network.nick_name,
      }
      MetatraderAutomaticCryptoDeposit.createWallet(data).then(res => {
        this.walletAddress = res.data.results.address
        this.inProgressDepositTime = +res.data.results.expired_at_in_second
        this.inProgressDepositExtendTime = +res.data.results.seconds_remaining
        if (+res.data.results.expired_at_in_second > 0) {
          clearTimeout(this.timerTimeout)
          this.counter()
        }
        this.inProgressDeposit = true
        this.$swal({
          title: res.data.message,
          icon: 'success',
          timer: 2500,
          showConfirmButton: false,
        })
      }).finally(() => {
        this.show = false
      })
    },
    async onCancelDeposit() {
      if (!this.inProgressDeposit) return
      this.show = true
      await MetatraderAutomaticCryptoDeposit.deactivateDeposit().then(async () => {
        this.inProgressDeposit = false
        this.walletAddress = ''
        this.inProgressDepositTime = 0
        this.$swal({
          title: this.$t('deposit_cancelled_successfully'),
          icon: 'success',
          timer: 2000,
          showConfirmButton: false,
        })
        await this.getActiveDeposit()
        this.list()
      }).finally(() => {
        this.show = false
      })
    },
    onExtendDeposit() {
      if (!this.inProgressDeposit) return
      this.show = true
      MetatraderAutomaticCryptoDeposit.extendDeposit().then(async res => {
        this.inProgressDepositTime = +res.data.results.expired_at_in_second
        this.inProgressDepositExtendTime = +res.data.results.seconds_remaining
        this.$swal({
          title: res.data.message,
          icon: 'success',
          timer: 2500,
          showConfirmButton: false,
        })
      }).finally(() => {
        this.show = false
      })
    },
    onNetworkChange(selectedNetwork) {
      if (selectedNetwork) {}
    },
    numberFormat(value) {
      // eslint-disable-next-line eqeqeq
      return this.numberWithCommas(value)
    },
    openInfoTransactionModal(val) {
      this.infoTransactionModal = true
      this.selectedTransaction = [{
        ...val,
        currency: val.currency.currency,
        amount: this.numberWithCommas(val.amount),
      }]
    },
    setBonusCode(code) {
      this.bonusCode = code
    },
    secondsToTime(seconds) {
      const date = new Date(0)
      date.setSeconds(seconds)
      const timeString = date.toISOString().substring(11, 19)
      return timeString
    },
    counter() {
      this.timerTimeout = setTimeout(() => {
        if (this.inProgressDepositTime > 0) {
          this.inProgressDepositTime -= 1
        }
        if (this.inProgressDepositExtendTime > 0) {
          this.inProgressDepositExtendTime -= 1
        }
        if (this.inProgressDepositTime > 0 || this.inProgressDepositExtendTime > 0) {
          clearTimeout(this.timerTimeout)
          this.counter()
        }
      }, 1000)
    },
    async getActiveDeposit() {
      await MetatraderAutomaticCryptoDeposit.getActiveWallet().then(res => {
        if (res.data.results.data) {
          this.inProgressDeposit = true
          this.inProgressDepositTime = +res.data.results.expired_at_in_second
          this.inProgressDepositExtendTime = +res.data.results.seconds_remaining
          clearTimeout(this.timerTimeout)
          this.counter()
          this.walletAddress = res.data.results.data.address
          this.formData.account = this.accountsItems.find(item => item.account === res.data.results.data.platform.account)
          this.formData.platform = this.platform.find(item => item.value === res.data.results.data.platform.platform)
          const findedCurrency = this.currencyItems.find(item => item.token === res.data.results.data.currency_network.currency.token)
          this.formData.currency = findedCurrency
          this.networkItems = findedCurrency.networks.map(network => ({
            ...network,
            name: `${network.network.name} (${network.network.nick_name})`,
          }))
          this.formData.network = this.networkItems.find(item => item.network.nick_name === res.data.results.data.currency_network.network.nick_name)
        } else {
          this.inProgressDeposit = false
          this.inProgressDepositTime = 0
          this.walletAddress = ''
          // this.formData.account = ''
          // this.formData.platform = ''
          // this.networkItems = []
          // this.formData.network = ''
        }
      })
    },
  },

}
</script>
  <style lang="scss">
  .card-border {
    border-right: 1px solid #e3e1e9;
  }

  .transaction-card {
    background-color: #efefef;
    padding: 15px;
    border-radius: 5px;
  }

  .card-bg {
    background-color: #172238;
    padding: 15px;
    border-radius: 5px;
  }

  .nameOfTheClass {
    padding: 20px !important;
  }
  </style>
  <style scoped>
  ::v-deep .qrcode{
    width: 150px;
    height: 150px;
  }
  ::v-deep .qrcode canvas{
    width: 100% !important;
  }
  </style>
